import React, {Component} from 'react'
import Inputs from '../../shared/FormComponents/Inputs'
import { Link } from 'react-router-dom';
import _ from 'lodash';
import './Login.css'

export default class Login extends Component {
    constructor(props) {
      super(props);
      this.state = {
        rememberme: false,
        loginData: {
            username: '',
            loginPassword: '',
        },
        inputStates: {
            username: false,
            loginPassword: false,
        }
      };
    }

    onDataChange = (key, value, valid) => {
        const state = _.extend({}, this.state);
        state.inputStates[key] = valid;
        state.loginData[key] = value;
        this.setState(state, () => this.validateForm());
    };

    validateForm = () => {
        let validationStates = _.extend({}, this.state.inputStates);
        let key = Object.values(validationStates).indexOf(false) !== -1;
        let state = !key;
        this.setState({ formValid: state });
    }

    Login = (e) => {
        e.preventDefault();
        let error = false;

        if (error) {
            return;
        }
        this.props.onLoginUser({
            login: this.state.loginData.username,
            password: this.state.loginData.loginPassword,
        });
    }

    changeRemember(value){
        this.setState({rememberme : value});
        localStorage.setItem('rememberMe', this.state.rememberme)
    }

    render() {
        return (
            <div className="login-content">
                <div className="login-content-layout">
                    <div className="card">
                        <div className='card-header'>
                            <div className="logo-bg-layout">
                                {/* <h5 className='card-title'>eToolkit</h5> */}
                                <div className='login-logo-box'></div>
                            </div>
                        </div>
                        <div className="card-body">
                            <h5>Please log in with your password to access The Planning Tools.</h5>
                            <form>
                                <div className="form-group icon-input">
                                    <i class="fas fa-envelope"></i>
                                    <Inputs
                                        type="login"
                                        className="form-control"
                                        value={this.state.loginData.username}
                                        required={ true }
                                        placeholder='Email'
                                        onChange={ (value, valid) => this.onDataChange('username', value, valid)} />
                                </div>
                                <div className="form-group icon-input">
                                    <i className="fas fa-unlock-alt"></i>
                                    <Inputs
                                        type="password"
                                        className="form-control"
                                        value={this.state.loginData.loginPassword}
                                        required={ true }
                                        placeholder='Password'
                                        onChange={ (value, valid) => this.onDataChange('loginPassword', value, valid)} />
                                </div>
                                <div className='form-group checkbox-field'>
                                    <label className='checkbox checked'>
                                        <input type='checkbox' checked={this.state.rememberme} onChange={(e) => this.changeRemember(e.target.checked)}/>
                                        Remember me
                                    </label>
                                </div>
                                <button
                                    type="submit"
                                    onClick={this.Login}
                                    disabled={!this.state.formValid || this.props.loginFetching}
                                    className="btn login-button">
                                    Login 
                                    {this.props.loginFetching && <i className="fa fa-spinner fa-spin fa-3x fa-fw"></i>}
                                </button>
                            </form>
                            <p className="forgot-password"><Link to="/forgot-password">Forgot Password</Link> or <Link to="/registration">Sign Up</Link> </p>
                        </div>

                    </div> 
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Login/Login.jsx